import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  REGION_CHANGE_EVENT,
  REGIONS,
  getRegion,
  isIndiaPath,
  setRegion,
} from "../utils/region";

export default function RegionSwitcher() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);
  const [region, setRegionState] = useState(() => getRegion() || REGIONS.ROW);
  const wrapRef = useRef(null);

  useEffect(() => {
    const sync = (event) => setRegionState(event.detail || getRegion() || REGIONS.ROW);
    window.addEventListener(REGION_CHANGE_EVENT, sync);
    return () => window.removeEventListener(REGION_CHANGE_EVENT, sync);
  }, []);

  useEffect(() => {
    if (isIndiaPath(pathname)) setRegionState(REGIONS.IN);
  }, [pathname]);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (event) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target)) setOpen(false);
    };
    const onKey = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    document.addEventListener("keydown", onKey);
    return () => {
      document.removeEventListener("mousedown", onDoc);
      document.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const current = region === REGIONS.IN ? "India" : "Rest of World";

  const choose = (next) => {
    setOpen(false);
    if (next === region) return;
    setRegion(next);
    setRegionState(next);
    if (next === REGIONS.IN) {
      navigate("/entering-in");
      return;
    }
    if (isIndiaPath(pathname)) navigate("/");
  };

  return (
    <div className="n-region" ref={wrapRef}>
      <button
        type="button"
        className="n-region-btn"
        aria-haspopup="listbox"
        aria-expanded={open}
        aria-label={`Region: ${current}. Change region`}
        onClick={() => setOpen((v) => !v)}
      >
        <span className="n-region-ico" aria-hidden="true">
          {region === REGIONS.IN ? "IN" : "WW"}
        </span>
        <span className="n-region-label">{current}</span>
        <span className="n-region-caret" aria-hidden="true">▾</span>
      </button>
      {open ? (
        <div className="n-region-menu" role="listbox" aria-label="Select region">
          <button
            type="button"
            role="option"
            aria-selected={region === REGIONS.IN}
            className={region === REGIONS.IN ? "is-active" : ""}
            onClick={() => choose(REGIONS.IN)}
          >
            India
            <span>Praesidio Studio</span>
          </button>
          <button
            type="button"
            role="option"
            aria-selected={region === REGIONS.ROW}
            className={region === REGIONS.ROW ? "is-active" : ""}
            onClick={() => choose(REGIONS.ROW)}
          >
            Rest of the World
            <span>Praesidio Care</span>
          </button>
        </div>
      ) : null}
    </div>
  );
}
